'use client';

import { FC } from 'react';
import { Swiper, SwiperProps, SwiperSlide } from 'swiper/react';

import Image from 'next/image';
import { EffectFade, Pagination } from 'swiper/modules';

import { TrustItemDataType } from '@screens/Main/model/types/mainPageData';
import { getImageUrl } from '@shared/utils/getImageUrl/getImageUrl';

import cls from './WhyUsSlider.module.scss';

type WhyUsSliderProps = {
  onInit: SwiperProps['onInit'];
  items: TrustItemDataType[];
};

type SlideProps = {
  image?: string;
  title?: string;
  text?: string;
};

const Slide: FC<SlideProps> = ({ image, title, text }) => (
  <div className={cls.item}>
    <div className={cls.icon}>
      {image && (
        <Image
          fill
          src={getImageUrl(image)}
          alt={'Иконка'}
        />
      )}
    </div>

    {title && <h2 className={cls.itemTitle}>{title}</h2>}
    {text && <div className={cls.textItem}>{text}</div>}
  </div>
);

export const WhyUsSlider: FC<WhyUsSliderProps> = ({ items, onInit }) => {
  const hasItems = !!items?.length;

  return hasItems ? (
    <>
      <Swiper
        className={cls.slider}
        modules={[Pagination, EffectFade]}
        pagination={{ clickable: true }}
        speed={1000}
        slidesPerView={1}
        {...{ onInit }}
      >
        {items.map((item) => (
          <SwiperSlide key={item.id}>
            <Slide
              image={item?.imageDesktop}
              title={item?.title}
              text={item?.text}
            />
          </SwiperSlide>
        ))}
      </Swiper>
      <div
        className={cls.textWrapper}
        data-testid="why-us-text-wrapper"
      >
        {items.map((item) => (
          <Slide
            key={item.id}
            image={item?.imageDesktop}
            title={item?.title}
            text={item?.text}
          />
        ))}
      </div>
    </>
  ) : null;
};
